import useGetRoleCustomer from './useGetRoleCustomer'

export default useGetRoleCustomer
